module.exports = __webpack_public_path__ + "media/images/admin/icons/skip-forward-f10f3a399e43e47b33e412da33746226.svg";